import { PageHeader } from '@/components/common/PageHeader';
import { SystemSettings as SystemSettingsComponent } from '@/components/settings';

/**
 * System Settings Page
 *
 * This page provides a comprehensive interface for configuring system-wide settings
 * including general configuration, security policies, KYC parameters, notifications,
 * and performance tuning.
 */
const SystemSettingsPage = () => {
  return (
    <div className='min-h-screen bg-background space-y-6 p-8'>
      <PageHeader
        title='System Settings'
        description='Configure global system defaults and policies.'
      />
      <SystemSettingsComponent />
    </div>
  );
};

export default SystemSettingsPage;
